
import TableList from "@components/templates/tablelist";
import { HttpPurchaseList} from '@/service/inbound';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true, align: 'right' },
            formData: {
                // search:{
                //     EQ_invalid:0
                // }
            },
            Searchs: {
                show: true,
                style: "border:none;",
                labelWidth: 'auto',
                align: "left"
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpPurchaseList,
        updateParent() {
            this.$emit('on-update');
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = params || this.checkedData;
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
        }
    },
    computed: {
        
        SearchsData() {
            return [{
                label:this.$t('fbb.inbound.purchase_order_no', { defaultValue: "采购单号" }),
                tag: 'vInput',
                key: 'EQ_poNo',
                show: true,
            },
            {
                label: "ERP SKU",
                tag: 'vInput',
                key: 'EQ_sku',
                show: true,
            }]
        },
        columns() {
            return [{
                type: 'selection',
                width: this.status === 'boxing' ? 60 : 0,
                formName: 'id',
            }, {
                title: "No.",
                type: 'index',
                width: 60,
            }, {
                title: this.$t('fbb.inbound.purchase_order_no', { defaultValue: "采购单号" }),
                key: 'poNo'
            }, {
                title: "ERP SKU",
                key: 'sku'
            },{
                title: this.$t('', { defaultValue: "计划数量" }),
                key: 'planShipQty'
            },]
        }
    }
};
